/**
 * Utility helpers for Draft Table Order detection.
 *
 * Draft Table Order documents live in a separate doctype ("Draft Table Order")
 * and their names start with "D-OR-" (e.g. "D-OR-2026-00002").
 * Regular Table Order names start with "OR-" (e.g. "OR-2026-00042").
 *
 * These helpers let any part of the frontend decide which doctype to target
 * for API calls.
 */

/**
 * Returns `true` when the given order (or order name) belongs to
 * the "Draft Table Order" doctype.
 */
export const isDraftTableOrder = (order) => {
    if (!order) return false;
    // Explicit doctype check (present when the full doc is available)
    if (order?.doctype === "Draft Table Order") return true;
    // Explicit status check (draft orders fetched directly may carry status)
    if (order?.status === "Draft") return true;
    // Name-prefix heuristic (works with both full docs and plain name strings)
    const name = typeof order === "string" ? order : order?.name;
    return typeof name === "string" && name.startsWith("D-OR-");
};

/**
 * Returns the doctype string to use for API calls that target this order.
 */
export const getOrderDoctype = (order) =>
    isDraftTableOrder(order) ? "Draft Table Order" : "Table Order";
